import React, { useState, useEffect } from "react";
import PatientAnswersOdlAdi from "../../components/patientanswersodladi/PatientAnswersOdlAdi";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";

const AdlScore = () => {
  let { id } = useParams();
  const [hasNoData, setHasNoData] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);

  const [testData, setTestData] = useState({
    test_date: "",
    test_score: 0,
    score_diff_from_last: 0,
  });

  const [isAnswersOpen, setAnswersOpen] = useState(false);
  const [answersLoaded, setAnswersLoaded] = useState(false);
  const [answersInfo, setAnswersInfo] = useState([]);
  const openCloseAnswers = (patient_id) => {
    if (!isAnswersOpen) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/patient-answers-questionnaires", {
          id: patient_id,
          questionnaire_id: 3,
        })
        .then((res) => {
          if (res.data.responseData) {
            setAnswersInfo(res.data.responseData);
            setAnswersLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setAnswersInfo([]);
      setAnswersLoaded(false);
    }
    setAnswersOpen(!isAnswersOpen);
  };

  useEffect(() => {
    if (id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/adl_test_details", { id })
        .then((res) => {
          if (res.data.responseData) {
            if (res.data.responseData.message === "no data found") {
              setHasNoData(true);
            } else {
              setHasNoData(false);
            }

            setDataLoading(false);

            if (res.data.responseData) {
              setTestData(res.data.responseData);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  return (
    <>
      <div className="patient_list_container pain_score_container">
        <div className="pain_score_top mb-16">
          <div className="title_container mb-16">
            <div className="title_painscore">ADL Score</div>
          </div>
          {dataLoading ? (
            <div className="p_load"></div>
          ) : hasNoData ? (
            <div className="score_card_top">No Data Found.</div>
          ) : (
            <div className="score_card">
              <div className="score_card_top">
                <div className="score_card_text" onClick={() => openCloseAnswers(id)}>
                  Latest ADL Score
                </div>
              </div>
              <div className="score_card_main">{testData.test_score}</div>
              <div
                className={"score_card_points " + (testData.score_diff_from_last > 0 ? " score_card_points_red" : "")}
              >
                <span>{testData.score_diff_from_last}pts</span>
              </div>
              <div className="score_text_small">*compared to the previous test</div>
              <div className="score_card_bottom">Test Taken at: {moment(testData.test_date).format("l")}</div>
            </div>
          )}
        </div>
      </div>
      {isAnswersOpen && (
        <PatientAnswersOdlAdi
          answersLoaded={answersLoaded}
          answersInfo={answersInfo}
          openCloseAnswers={openCloseAnswers}
        />
      )}
    </>
  );
};

export default AdlScore;
